import React, { FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../../constants/aampeTheme';

// models
import { GamificationItemModel } from '../../../../../models/label.model';

// components
import LabelGamificationRow from './LabelGamificationRow';

interface LabelGamificationListProps {
    color: string;
    gamificationItemList: GamificationItemModel[];
    className?: string;
}
const LabelGamificationList: FC<
    React.PropsWithChildren<LabelGamificationListProps>
> = ({ gamificationItemList, color, className }) => {
    return (
        <LabelsList className={className}>
            {gamificationItemList.map((gamificationItem) => (
                <LabelGamificationRow
                    key={gamificationItem.id}
                    gamificationItem={gamificationItem}
                    color={color}
                />
            ))}
        </LabelsList>
    );
};

export default LabelGamificationList;
const LabelsList = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
});
